import React, { useState } from "react";
import { View, Text, ActivityIndicator } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { LinearGradient } from "expo-linear-gradient";
import { ActionButton } from "@/components/ActionButton";
import Icons from "@/assets/icons";
import { router } from "expo-router";

const ReSubscribeSuccessScreen = () => {
  const [isNavigating, setIsNavigating] = useState(false);

  const handleBackToHome = async () => {
    try {
      setIsNavigating(true);
      // Small delay to show loading state
      await new Promise((resolve) => setTimeout(resolve, 500));
      // Navigate back to the main tabs screen
      router.dismissTo("/(tabs)/feeds");
    } catch (error) {
      console.error("Navigation error:", error);
    } finally {
      setIsNavigating(false);
    }
  };

  return (
    <View style={styles.container}>
      <LinearGradient
        colors={["#26913B", "#243D3C"]}
        style={styles.gradient}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
      >
        {/* Loading Overlay */}
        {isNavigating && (
          <View style={styles.loadingOverlay}>
            <ActivityIndicator size="large" color="#FFFFFF" />
          </View>
        )}

        <View style={[styles.content, isNavigating && { opacity: 0.7 }]}>
          {/* Logo Icon */}
          <View style={styles.iconContainer}>
            <View style={styles.iconCircle}>
              <Icons.Logo width={32} height={32} color="#FFFFFF" />
            </View>
          </View>

          {/* Title */}
          <Text style={styles.title}>
            You&apos;ve reactivated your{"\n"}Sparrow membership!
          </Text>

          {/* Subtitle */}
          <Text style={styles.subtitle}>
            Your Sparrow account has been reactivated!{"\n"}
            All your existing claims will be filed. You&apos;ll{"\n"}
            continue to receive notifications about new{"\n"}
            claim opportunities.
          </Text>
        </View>

        {/* Bottom Action */}
        <View style={styles.bottomSection}>
          <ActionButton
            title={isNavigating ? "Loading..." : "Back to home"}
            onPress={handleBackToHome}
            disabled={isNavigating}
            icon={
              isNavigating ? (
                <ActivityIndicator size="small" color="#FFFFFF" />
              ) : undefined
            }
          />
        </View>
      </LinearGradient>
    </View>
  );
};

export default ReSubscribeSuccessScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    flex: 1,
    paddingHorizontal: 32,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 60,
  },
  iconContainer: {
    marginBottom: 40,
  },
  iconCircle: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: 28,
    fontWeight: "700",
    color: "#FFFFFF",
    textAlign: "center",
    marginBottom: 24,
    lineHeight: 36,
  },
  subtitle: {
    fontSize: 16,
    color: "#FFFFFF",
    textAlign: "center",
    lineHeight: 24,
    opacity: 0.9,
  },
  bottomSection: {
    paddingBottom: 50,
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
  },
});
